module.exports = "/_next/static/images/Security-md-010566afcd4f4b17cb5373c18f3ffa83.png";